import { render, staticRenderFns } from "./VideoWithTimeline.vue?vue&type=template&id=a4b87124&lang=pug"
import script from "./VideoWithTimeline.vue?vue&type=script&lang=js"
export * from "./VideoWithTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports